import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateUser, User } from 'src/app/shared/interfaces/user.interface';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent {
  createUserForm!: FormGroup;
  successMessage!: string;
  showSuccess!: boolean;
  showError!: boolean;
  errorMessage = '';
  isSentRequest = false;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.createUserForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
    });
  }

  createUser() {
    const newUser: CreateUser = {
      firstName: this.createUserForm.get('firstName')?.value,
      lastName: this.createUserForm.get('lastName')?.value
    };
    // if (this.createUserForm.valid) {
    //   this.authService.createUser(newUser).subscribe({
    //     next: () => this.showSuccess = true,
    //     error: (err: HttpErrorResponse) => {
    //       this.showError = true;
    //       this.errorMessage = err.message;
    //     }
    //   })
    // } else {
    //   this.errorMessage = 'Fill all the required field!';
    // }
  }

  hasError(controlName: string, errorName: string) {
    return this.createUserForm.controls[controlName].hasError(errorName);
  }

}
